import { Text } from '@chakra-ui/react';
import { Label as RLabel } from 'reactstrap';
import React from 'react';

export const Label = ({
	children,
	isRequired,
	fontFamily = 'Poppins Light',
	titleColor
}) => {
	return (
		<Text
			color={titleColor}
			fontSize={12}
			fontFamily={fontFamily}
			marginBottom="4px !important"
		>
			{children}
			{isRequired && (
				<RLabel
					className="text-primary font-weight-lighter"
					style={{ marginLeft: 5, marginBottom: 0 }}
				>
					*
				</RLabel>
			)}
		</Text>
	);
};
